import React,{useState} from 'react';
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
} from '@react-pdf/renderer';
import chunk from 'lodash/chunk';

// Gaya untuk PDF
const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 8,
    fontFamily: 'Helvetica',
    position: 'relative',
  },
  title: {
    fontSize: 12,
    marginBottom: 10,
    textAlign: 'center',
  },
  sectionTitle: {
    fontSize: 10,
    marginTop: 6,
    marginBottom: 2,
    fontWeight: 'bold',
  },
  subSectionTitle: {
    fontSize: 9,
    marginTop: 4,
    marginBottom: 2,
    fontWeight: 'bold',
    marginLeft: 10,
  },
  subSubSectionTitle: {
    fontSize: 8,
    marginTop: 2,
    marginBottom: 2,
    fontWeight: 'bold',
    marginLeft: 20,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 0.5,
    borderColor: '#ccc',
    paddingVertical: 2,
    marginLeft: 30,
  },
  tableHeader: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderTopWidth: 1,
    borderColor: '#000',
    paddingVertical: 3,
    backgroundColor: '#eee',
  },
  cell: {
    paddingHorizontal: 3,
  },
  colChartCode: { width: '20%' },
  colChartDesc: { width: '50%' },
  colJumlah: { width: '30%', textAlign: 'right' },
  footerRow: {
    flexDirection: 'row',
    backgroundColor: '#f9f9f9',
    borderTopWidth: 1,
    borderColor: '#000',
    paddingTop: 2,
    marginLeft: 30,
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 10,
    top: 10,
    right: 30,
    textAlign: 'right',
    color: 'grey',
  },
});

// Fungsi untuk mengelompokkan data berdasarkan beberapa kunci
const groupByMultipleKeys = (data, keys) => {
  if (keys.length === 0) return data;
  const [firstKey, ...restKeys] = keys;
  const grouped = data.reduce((acc, item) => {
    const key = item[firstKey];
    if (!acc[key]) acc[key] = [];
    acc[key].push(item);
    return acc;
  }, {});
  for (const key in grouped) {
    grouped[key] = groupByMultipleKeys(grouped[key], restKeys);
  }
  return grouped;
};

// Fungsi untuk memformat angka sebagai mata uang
const formatCurrency = val => Number(val || 0).toLocaleString('id-ID');

const formatDateTime = (tanggal) => {
  // const inputTanggal = "01-02-2025"; // dd-mm-yyyy
const [dd, mm, yyyy] = tanggal.split("-");
const convertedTanggal = `${yyyy}-${mm}-${dd}`;
const tgl = new Date(convertedTanggal); // contoh input, pastikan ini Date object ya
  const formatted = tgl.toLocaleDateString('id-ID', {
    month: 'long',
    year: 'numeric'
});

  return formatted;
};

const formatDateTime1 = () => {
  const d = new Date();
  const day = String(d.getDate()).padStart(2, '0');
  const month = ["Januari", "Februari", "Maret", "April", "Mei", "Juni",
                 "Juli", "Agustus", "September", "Oktober", "November", "Desember"][d.getMonth()];
  const year = d.getFullYear();
  const time = d.toTimeString().split(' ')[0]; // ambil HH:MM:SS

  return `${day}-${month}-${year} ${time}`;
};

// Komponen PDF
const MyReportneracadtlmon = ({ data = [], tanggal, userBy }) => {
  const groupedData = groupByMultipleKeys(data, [
    'group_account_div',
    'group_account_dep',
    'group_account_desc'
  ]);
   const [period,setPeriod] = useState(formatDateTime(tanggal))
   const [date, setDate] = useState(formatDateTime1());
  

  const rows = [];

  Object.entries(groupedData).forEach(([divKey, divGroup]) => {
    // Judul Level 1: group_account_div
    rows.push(
      <Text key={`div-${divKey}`} style={styles.sectionTitle}>
        {divKey}
      </Text>
    );

    Object.entries(divGroup).forEach(([depKey, depGroup]) => {
      // Judul Level 2: group_account_dep
      rows.push(
        <Text key={`dep-${divKey}-${depKey}`} style={styles.subSectionTitle}>
          {depKey}
        </Text>
      );

      Object.entries(depGroup).forEach(([codeKey, records]) => {
        // Judul Level 3: group_account_code
        rows.push(
          <Text
            key={`code-${divKey}-${depKey}-${codeKey}`}
            style={styles.subSubSectionTitle}
          >
            {codeKey}
          </Text>
        );

        // Detail Akun
        records.forEach((r, i) => {
          rows.push(
            <View
              style={styles.tableRow}
              key={`row-${divKey}-${depKey}-${codeKey}-${i}`}
            >
              <Text style={[styles.cell, styles.colChartCode]}>
                {r.chart_account_code}
              </Text>
              <Text style={[styles.cell, styles.colChartDesc]}>
                {r.chart_account_desc}
              </Text>
              <Text style={[styles.cell, styles.colJumlah]}>
                {formatCurrency(r.jumlah)}
              </Text>
            </View>
          );
        });

        // Subtotal untuk group_account_code
        const subtotalCode = records.reduce(
          (sum, r) => sum + (r.jumlah || 0),
          0
        );
        rows.push(
          <View
            style={styles.footerRow}
            key={`subtotal-code-${divKey}-${depKey}-${codeKey}`}
          >
            <Text style={[styles.cell, styles.colChartCode]}>Subtotal</Text>
            <Text style={[styles.cell, styles.colChartDesc]}></Text>
            <Text style={[styles.cell, styles.colJumlah]}>
              {formatCurrency(subtotalCode)}
            </Text>
          </View>
        );
      });

      // Subtotal untuk group_account_dep
      const subtotalDep = Object.values(depGroup).flat().reduce(
        (sum, r) => sum + (r.jumlah || 0),
        0
      );
      rows.push(
        <View
          style={styles.footerRow}
          key={`subtotal-dep-${divKey}-${depKey}`}
        >
          <Text style={[styles.cell, styles.colChartCode]}>Subtotal</Text>
          <Text style={[styles.cell, styles.colChartDesc]}></Text>
          <Text style={[styles.cell, styles.colJumlah]}>
            {formatCurrency(subtotalDep)}
          </Text>
        </View>
      );
    });

    // Subtotal untuk group_account_div
    const subtotalDiv = Object.values(divGroup)
      .flatMap(dep => Object.values(dep).flat())
      .reduce((sum, r) => sum + (r.jumlah || 0), 0);
    rows.push(
      <View style={styles.footerRow} key={`subtotal-div-${divKey}`}>
        <Text style={[styles.cell, styles.colChartCode]}>Subtotal</Text>
        <Text style={[styles.cell, styles.colChartDesc]}></Text>
        <Text style={[styles.cell, styles.colJumlah]}>
          {formatCurrency(subtotalDiv)}
        </Text>
      </View>
    );
  });

  const rowsPerPage = 50; // Sesuaikan dengan kebutuhan
  const pages = chunk(rows, rowsPerPage);

  return (
    <Document>
      {pages.map((rowsChunk, idx) => (
        <Page
          key={idx}
          size="A4"
          orientation="portrait"
          style={styles.page}
        >
          <Text
            style={styles.pageNumber}
            render={({ pageNumber, totalPages }) =>
              `Halaman: ${pageNumber} dari ${totalPages}`
            }
            fixed
          />
          <Text style={styles.title}>
            Laporan Neraca Detail &nbsp;&nbsp; Tanggal: {period}  
          </Text>          
          <Text>Tanggal :{date} &nbsp;&nbsp; user by : {userBy} </Text>
          <View style={styles.tableHeader} fixed>
            <Text style={[styles.cell, styles.colChartCode]}>
              Chart Code
            </Text>
            <Text style={[styles.cell, styles.colChartDesc]}>
              Chart Desc
            </Text>
            <Text style={[styles.cell, styles.colJumlah]}>Jumlah</Text>
          </View>
          {rowsChunk}
        </Page>
      ))}
    </Document>
  );
};

export default MyReportneracadtlmon;
